import React, { useEffect, useState } from 'react'
import { useLocation, Redirect } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import logo from '../../assets/img/logo.png';
import BottomLogo from '../../assets/img/bottom_logo.png';
import { useTranslation, withTranslation } from 'react-i18next';
import Button from '../../components/Button/Button'
import './Login.scss';
import { masterActions } from '../../_actions';
import { useDispatch, useSelector } from 'react-redux';
import { Base64 } from 'js-base64';
import 'react-toastify/dist/ReactToastify.css'


const Login = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation();
	const loginPage = useSelector(state => state.loginPage);
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const location = useLocation();
	function handleSubmit(e) {
		e.preventDefault()
		console.log(username)
		console.log(password)
		const encriptedPassoword = Base64.encode(password)
		const { from } = location.state || { from: { pathname: '/Dashboard' } }
		dispatch(masterActions.login(username, encriptedPassoword, from))
		dispatch(masterActions.isLoggedIn(true))
	}

	return (
		<Grid className="LoginContainer">
			{localStorage.getItem('userData') ? <Redirect to='/Dashboard' /> : null}
			<div className="container login_sec">
				<div className="row">
					<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12 mb-4">
						<div className="login_left_sec">
							<img alt="logo" src={logo} />
							<div className="left_txt">
								<h4 className="head_txt">Welcome to the Insee Plus</h4>
								{/* <div className="address_dtl">
									<span> <i class="fa fa-phone" aria-hidden="true"></i> +6666 297-7000</span><br />
									<span> <i class="fa fa-envelope" aria-hidden="true"></i> Welcome@siamcitycement.com</span>
								</div> */}

							</div>
						</div>

					</div>
					<div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
						<div className="login_img">
							<div className="login_right_sec">
								<div className="title-heading">
									{loginPage && loginPage.error !== undefined || null ? <span>{loginPage.error}</span> : ''}

									<h4 className="head_txt">
										Log In
									</h4>
								</div>
								<div className="Login_Section form_section">
									<form onSubmit={handleSubmit} method="POST">
										<div className="inputBox ">
											<input type={"text"} name={"username"} onChange={event => setUsername(event.target.value)} placeholder="UserName" className="input" autoComplete="off" />
										</div>

										<div className="inputBox mb-1">
											<input type={"password"} name={"password"} onChange={event => setPassword(event.target.value)} placeholder="Password" className="input" autoComplete="off" />
										</div>
										<div className='inputBox text-right mb-4'>
										</div>

										<Button type={"submit"} label={t("login.button")} />
									</form>
								</div>
							</div>
						</div>


					</div>
				</div>

			</div>

			<div className="container bottom_logo">
				<div className="row">
					<img src={BottomLogo} />
				</div>
			</div>

		</Grid>
	);
}

export default withTranslation()(Login);
